// React
import { ReactElement, useState } from 'react';
// Design System
import { MyTableCell, MyTableCellProps } from './MyTableCell';
// Styles
import styles from './my-table.module.scss';

export interface MyTableRowProps {
    children: ReactElement<MyTableCellProps> | (ReactElement<MyTableCellProps> | false)[];
    className?: string;
    showDetailsClassName?: string;
    height?: number;
}

export const MyTableRow = (props: MyTableRowProps): ReactElement => {
    const { children, className, height, showDetailsClassName } = props;

    const [showMore, setShowMore] = useState(false);

    // Check if the table contains at least one cell that will be
    // hidden on mobile to know if the show more button need to be
    // show or hidden
    let hideMoreButton: boolean;
    let hideMoreButtonDesktop: boolean;
    let content;

    if (Array.isArray(children)) {
        hideMoreButton = children.filter((child) => child && child.props.hiddenOnMobile).length === 0;
        hideMoreButtonDesktop = children.filter((child) => child && child.props.hiddenOnDesktop).length === 0;
        // children.map((child) => { child.props.height = height });

        content = children.filter(Boolean).map((child) => child && <MyTableCell {...child.props} height={height}></MyTableCell>);
    } else {
        hideMoreButton = !Boolean(children.props.hiddenOnMobile);
        hideMoreButtonDesktop = !Boolean(children.props.hiddenOnDesktop);
        // children.props.height = height;
    }

    // Define the CSS classes
    const classesCSS = [
        className,
        styles.row,
        hideMoreButton && styles.hide_show_more_button,
        hideMoreButtonDesktop && styles.hide_show_more_button_desktop,
        showMore && styles.show_details,
        showMore && showDetailsClassName,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={classesCSS}>
            {content}
            <div className={styles.show_more} onClick={() => setShowMore(!showMore)}>
                <div className={styles.dot}></div>
            </div>
            <div className={styles.break_line_mobile}></div>
        </div>
    );
};
